export const UserAccountBalanceRptConstants ={
    GETALL_REQUEST: 'USERACCOUNTBAL_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERACCOUNTBAL_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERACCOUNTBAL_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'USERACCOUNTBAL_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'USERACCOUNTBAL_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'USERACCOUNTBAL_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}